/* eslint-disable camelcase */

export const ProductTypesUrl: any = {
  sr: {
    phone: "Mobilni-telefoni",
    modem: "Modemi",
    accessory: "Dodatna-oprema",
    bt_headphone: "Dodatna-oprema",
    headphone: "Dodatna-oprema",
    drivey: "Dodatna-oprema",
    memory: "Dodatna-oprema",
    charger: "Dodatna-oprema",
    purse: "Dodatna-oprema",
    watches_and_bracelets: "Satovi-i-narukvice",
    watch: "Satovi-i-narukvice",
    myki: "Satovi-i-narukvice",
    smart_band: "Satovi-i-narukvice",
    tablet: "Tableti",
    laptop: "Laptopovi",
    tv: "TV",
    optics_equipment: "Fiksni-i-oprema",
    landline: "Fiksna",
    ott: "OTT",
    postpaidott: "Postpaid-OTT",
  },
  en: {
    phone: "Mobile-phones",
    modem: "Modems",
    accessory: "Additional-accessories",
    bt_headphone: "Additional-accessories",
    headphone: "Additional-accessories",
    drivey: "Additional-accessories",
    memory: "Additional-accessories",
    charger: "Additional-accessories",
    purse: "Additional-accessories",
    watches_and_bracelets: "Watches-and-bracelets",
    watch: "Watches-and-bracelets",
    myki: "Watches-and-bracelets",
    smart_band: "Watches-and-bracelets",
    tablet: "Tablets",
    laptop: "Laptops",
    tv: "TV",
    optics_equipment: "Optics-equipment",
    landline: "Landline",
    ott: "OTT",
    postpaidott: "Postpaid-OTT",
  }
};

export default ProductTypesUrl;
